const supportedBlockIds = [
  'cover-with-features-and-side-media',
  'cover-with-plain-text-and-media-bg-image',
  'cover-with-tablet',
  'cover-with-laptop-and-phone',
  'cover-with-numbers-and-cta',
  'cover-with-phone',
  'cover-with-phone-bg-image',
  'cover-with-media',
  'cover-with-side-media',
  'cover-with-media-bg-image',
  'cover-with-horizontal-layout',
  'cover-with-video-embed-bg-image',
  'cover-with-video-embed',
  'services-with-accordion-and-side-media',
  'product-with-media',
  'about-with-features-and-scribbles',
  'about-with-features',
  'about-splitscreen-with-media',
  'about-with-media',
  'cta-banner-with-media',
  'team-member-with-media',
  'menu-with-media',
  'media-with-laptop',
  'media-with-laptop-bg-image',
  'media-bg-image',
  'media',
  'media-fullwidth',
  'video-embed-with-laptop-bg-image',
  'video-embed',
  'video-embed-with-laptop',
  'video-embed-bg-image',
  'widget-image',
  'widget-video',
];

export default supportedBlockIds;
